import marked from 'marked'

export default {
  methods: {
    compiledMarkdown: function (markdown) {
      return marked(markdown, { sanitize: true })
    },

    slugify (str) {
      const first = str.replace(/['*+~, .()"!:@]/g, '-').toLowerCase()
      return first.replace(/^-+|-+(?=-|$)/g, '')
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/UtilsMixin.js